import { MascotAvatar } from "./MascotAvatar";

interface Props {
  title: string;
  subtitle?: string;
  vibe?: "calm" | "celebratory";
}

export function EmptyState({ title, subtitle, vibe = "calm" }: Props) {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 px-6 py-12 text-center">
      <div className="relative">
        <MascotAvatar size={88} />
        {vibe === "celebratory" && (
          <div className="absolute -right-2 -top-2 text-2xl">✨</div>
        )}
      </div>
      <div>
        <div className="font-display text-xl font-semibold tracking-display text-text">
          {title}
        </div>
        {subtitle && (
          <div className="mt-1 max-w-md text-sm text-text-muted">{subtitle}</div>
        )}
      </div>
    </div>
  );
}
